/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-23 18:16:44
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-06-14 11:29:33
 * @FilePath: /goldenSalesMobile/src/utils/http.js
 * @Description: axios封装
 */
import router from "@/router/index";
import { Toast } from "vant";
import { loading } from "@/utils/index";
import axios from "axios"; //引入axios
import { urlEncode, handleLocalStorage } from "@/utils/index";
import store from "@/store";
import { getToken, removeToken, getLocalOpenId } from "./auth"; //获取到token
import { handlerlogin } from "@/permission";

//创建一个axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  timeout: 10000,
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // loading()
    let vpnNumber = store.state.vpnNumber;
    if (vpnNumber) {
      config.headers["VpnNumber"] = vpnNumber;
    }
    let token = getToken();
    if (token) {
      config.headers["Authorization"] = token;
    }
    // let openId = store.state.OpenId;
    // if (openId) {
    //   config.headers['OpenId'] = openId
    // }
    // TODO 更新测试环境续注释
    // config.headers['OpenId'] = 'oQnR6wHMDufNDW-v8gcC0AOazOZA'
    return config;
  },
  (error) => {
    Toast.clear();
    return Promise.reject(error);
  }
);

//响应拦截器
service.interceptors.response.use(
  (response) => {
    Toast.clear();

    const res = response.data;

    if (res.Code && res.Code !== 10000) {
      if (res.Msg == "身份未授权") {
        const nowRouteData = router.currentRoute;
        handleLocalStorage.set("registerAfterPage", {
          name: nowRouteData.name,
          query: nowRouteData.query,
          params: nowRouteData.params,
        });

        Toast({
          message: res.Msg + "，请先注册微会员",
          duration: 3000,
        });
        setTimeout(() => {
          router.push({
            name: "ValidMember",
          });
        }, 2000);
      } else if (response.config.url.indexOf("bindinginfo") != -1) {
        return res.Msg;
      } else {
        Toast({
          message: res.Msg,
          duration: 3000,
        });
      }
      return Promise.reject(new Error(res.Msg || "Error"));
    } else {
      let resContent = res.Content === 0 || res.Content ? res.Content : res;
      return resContent;
    }
  },
  (error) => {
    Toast.clear();
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = "错误请求";
          break;
        case 401:
          error.message = "登录失效，自动重新登录";

          // router.replace({ name: 'Login' })
          // removeToken()
          // window.location.replace(`${window.location.href.split('#/')[0]}#/login`)
          break;
        case 405:
          error.message = "请求方法不被允许";
          break;
        case 500:
          error.message = "服务器端错误";
          break;
        case 503:
          error.message = "服务不可用";
          break;
        default:
          error.message = `连接错误${error.response.status}`;
          break;
      }
    } else {
      // 获取不到状态码或其他状态的处理
      error.message = "网络出现问题，请稍后再试";
    }
    Toast({
      message: error.message,
      duration: 2000,
    });
    if (error && error.response && error.response.status == 401) {
      handlerlogin().then((res) => {
        location.reload();
      });
    }
    return Promise.reject(error);
  }
);

export default service;

export function requestOfGet(url, param) {
  let _param;
  if (param) {
    _param = JSON.parse(JSON.stringify(param));
    if (
      _param.pager &&
      "pageindex" in _param.pager &&
      _param.pager.pageindex > 0
    ) {
      _param.pager.pageindex--;
    }

    console.log(url + "?" + urlEncode(_param))
    return service.get(url + "?" + urlEncode(_param));
  }
  return service.get(url);
}

export function requestOfPut(url, param) {
  return service.put(url, param);
}

export function requestOfPost(url, param) {
  return service.post(url, param);
}

export function requestOfDelete(url, param) {
  return service.delete(url, param);
}


export function $http(
  url,
  param = {},
  method = "get",
  otherObj = {
    // method: 'get',
    showToast: true,
    toBody: false,
  }
) {
  if (otherObj.showToast) {
    loading();
  }
  if (method !== "get") {
    return service[method](url, param);
  }
  let _param;
  if (param) {
    _param = JSON.parse(JSON.stringify(param));
    if (
      _param.pager &&
      "pageindex" in _param.pager &&
      _param.pager.pageindex > 0
    ) {
      _param.pager.pageindex--;
    }
    let splitParams = "";
    if (Object.keys(_param).length !== 0) {
      splitParams = "?" + urlEncode(_param);
    }
    return service.get(url + splitParams);
  }
  return service.get(url);
}

export function testUrl(url, params) {
  return service.get(url, { params: params });
}
